
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-64a807cc!sass-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./FilterPanel.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./FilterPanel.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-64a807cc!../../node_modules/vue-loader/lib/selector?type=template&index=0!./FilterPanel.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/FilterPanel.vue
// module id = 524
// module chunks = 2